<div class="tw-flex tw-justify-center tw-gap-2 tw-px-2">
	<input
		*ngFor="let i of inputs; let idx = index"
		#otpInput
		type="text"
		maxlength="1"
		inputmode="numeric"
		pattern="[0-9]*"
		[value]="otp[idx] || ''"
		(input)="onInput($event, idx)"
		(keydown)="onKeyDown($event, idx)"
		(paste)="onPaste($event, idx)"
		class="tw-flex-1 tw-max-w-[44px] tw-h-12 tw-text-center tw-text-2xl tw-font-medium tw-text-gray-900 tw-bg-gray-100 tw-border tw-border-gray-300 tw-rounded-md focus:tw-border-blue-500 focus:tw-ring-1 focus:tw-ring-blue-500 sm:tw-w-12 sm:tw-flex-none"
		[attr.aria-label]="'OTP digit ' + (idx + 1)"
	/>
</div>
